/* istanbul ignore file - better tested visually */
import {
  WizardPageContent,
  WizardPageFooter,
  WizardPageHeader,
  WizardPageLayout,
} from '@partful/shared/ui/layouts/WizardPageLayout';
import { Typography } from '@partful/shared/ui/Typography';
import { ReactNode } from 'react';
import { ErrorMessage } from '../ErrorMessage';
import styles from './WizardErrorPage.module.scss';

type WizardErrorPageProps = {
  errorIcon: ReactNode;
  errorTitle: ReactNode;
  errorMessage?: ReactNode;
  errorActions?: ReactNode;
  pageTitle?: ReactNode;
  pageSubtitle?: string;
  footer?: ReactNode;
};

export function WizardErrorPage({
  pageSubtitle,
  pageTitle,
  errorIcon,
  errorTitle,
  errorMessage,
  errorActions,
  footer,
}: Readonly<WizardErrorPageProps>) {
  return (
    <WizardPageLayout>
      {(pageTitle || pageSubtitle) && (
        <WizardPageHeader>
          {pageTitle && (
            <Typography appearance="heading5" as="h1">
              {pageTitle}
            </Typography>
          )}
          {pageSubtitle && (
            <Typography appearance="heading6" as="h2">
              {pageSubtitle}
            </Typography>
          )}
        </WizardPageHeader>
      )}
      <WizardPageContent className={styles.error}>
        <ErrorMessage icon={errorIcon} title={errorTitle} message={errorMessage} actions={errorActions} />
      </WizardPageContent>
      {footer && <WizardPageFooter>{footer}</WizardPageFooter>}
    </WizardPageLayout>
  );
}
